export class Tab {

  constructor(app) {

    $('[data-role="tabNav"]').each((i,el) => {
      this.initTab(el);
    });

    $('[data-role="tabNavSp"]').each((i,el) => {
      this.tabNavSp(el);
    });

    
  }

  tabNavSp(el){
    var tabNavSp = $(el);
    tabNavSp.click(this.onClickTabNavSp.bind(this));
  }
  
  onClickTabNavSp(e){
    this.openTabNavSp(e);
  }
  
  openTabNavSp(e){
    var tabNavSp = $(e.currentTarget);
    var tabNav = tabNavSp.closest('.tab-nav2');
    tabNav.addClass('is-open');
  }
  
  closeTabNavSp(){
    $('.tab-nav2').removeClass('is-open');
  }

  initTab(el) {
    let header = $(el);
    let link,href,content;
    
    try{
      header.find('a').each((i,el)=>{
        link = $(el);
        href = link.attr('href');
        content = $(href);
        if(link.hasClass(CLASS_IS_ACTIVE)){
          content.addClass(CLASS_IS_ACTIVE);
        }
        link.click(this.onClick.bind(this));
      });
      
    }catch(e){
      console.log(e);      
    }
    
  }
  
  onClick(e){
    e.preventDefault();
    
    this.closeTabNavSp();
    
    let link,otherLinks,nav,href,content,title;
    link = $(e.currentTarget);
    nav = link.closest('[data-role="tabNav"]');
    otherLinks = nav.find('a').not(link);
    otherLinks.removeClass(CLASS_IS_ACTIVE);
    link.addClass(CLASS_IS_ACTIVE);
    
    title = $('[data-role="tabTitle"]');
    if(title){
      title.text(link.text());  
    }
    
    otherLinks.each((i,el)=>{
      content = $($(el).attr('href')).removeClass(CLASS_IS_ACTIVE);
    });
    $(link.attr('href')).addClass(CLASS_IS_ACTIVE);
  }

}